import moment from 'moment';

export const VENDOR_ID = 3;

export const SEARCH_DEBOUNCE_TIME = 500;

export const SORT_ORDER = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const PAGE_SIZE = 10;

export const DEFAULT_SORT_ORDER = SORT_ORDER.ASC;

export const DATE_FORMAT = 'YYYY-MM-DD';

export const AUTO_COMPLETE_STYLES = {
  vueSimpleSuggest: 'position-relative',
  inputWrapper: '',
  defaultInput: 'form-input full-width form-control',
  suggestions: 'position-absolute list-group z-1000',
  suggestItem: 'list-group-item',
};

export const REQUEST_DATE = {
  TODAY: 'Today',
  YESTERDAY: 'Yesterday',
  THIS_WEEK: 'This week',
  LAST_WEEK: 'Last week',
  LAST_7_DAYS: 'Last 7 days',
  THIS_MONTH: 'This month',
  LAST_MONTH: 'Last month',
  LAST_30_DAYS: 'Last 30 days',
  THIS_QUARTER: 'This quarter',
  LAST_QUARTER: 'Last quarter',
  THIS_YEAR: 'This year',
  LAST_YEAR: 'Last year',
  CUSTOM: 'Custom',
};

export const TODAY = moment().format(DATE_FORMAT);

export const ALERT_LOCATION = {
  INVENTORY_GRID: 'InventoryGrid',
  PART_INVENTORY: 'PartInventory',
};

export const ATTRIBUTE_NAME = {
  TOP_100: 'TOP 100',
  TOP_50: 'TOP 50',
  TOP_20: 'TOP 20',
};

export const RFP_STATUS = {
  OPEN: 1,
  CLOSED: 2,
};

export const GRID_ID = {
  COMPANY: 'company',
  RFP: 'rfp',
  INVENTORY: 'inventory',
  REQUIREMENT: 'requirement',
  RFP_GRID_PARTS: 'rfpGridParts',
};

export const GRID_PAGE_SIZES = [5, 10, 20, 50];

export const CACHE_TIMEOUT = 3 * 60 * 60 * 1000; // 3 hours

export const EXP_MONTH = [
  { id: 1, name: '01' },
  { id: 2, name: '02' },
  { id: 3, name: '03' },
  { id: 4, name: '04' },
  { id: 5, name: '05' },
  { id: 6, name: '06' },
  { id: 7, name: '07' },
  { id: 8, name: '08' },
  { id: 9, name: '09' },
  { id: 10, name: '10' },
  { id: 11, name: '11' },
  { id: 12, name: '12' },
];


export const REGEX = {
  isPhone: /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/,
  isFax: /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/
}

export const STATES = [
  {
    'id': 0,
    'abbr': '--',
    'name': ''
  },
  {
    'id': 1,
    'abbr': 'AK',
    'name': 'Alaska'
  },
  {
    'id': 2,
    'abbr': 'AL',
    'name': 'Alabama'
  },
  {
    'id': 3,
    'abbr': 'AR',
    'name': 'Arkansas'
  },
  {
    'id': 4,
    'abbr': 'AZ',
    'name': 'Arizona'
  },
  {
    'id': 5,
    'abbr': 'CA',
    'name': 'California'
  },
  {
    'id': 6,
    'abbr': 'CO',
    'name': 'Colorado'
  },
  {
    'id': 7,
    'abbr': 'CT',
    'name': 'Connecticut'
  },
  {
    'id': 8,
    'abbr': 'DC',
    'name': 'District of Columbia'
  },
  {
    'id': 9,
    'abbr': 'DE',
    'name': 'Delaware'
  },
  {
    'id': 10,
    'abbr': 'FL',
    'name': 'Florida'
  },
  {
    'id': 11,
    'abbr': 'GA',
    'name': 'Georgia'
  },
  {
    'id': 12,
    'abbr': 'HI',
    'name': 'Hawaii'
  },
  {
    'id': 13,
    'abbr': 'IA',
    'name': 'Iowa'
  },
  {
    'id': 14,
    'abbr': 'ID',
    'name': 'Idaho'
  },
  {
    'id': 15,
    'abbr': 'IL',
    'name': 'Illinois'
  },
  {
    'id': 16,
    'abbr': 'IN',
    'name': 'Indiana'
  },
  {
    'id': 17,
    'abbr': 'KS',
    'name': 'Kansas'
  },
  {
    'id': 18,
    'abbr': 'KY',
    'name': 'Kentucky'
  },
  {
    'id': 19,
    'abbr': 'LA',
    'name': 'Louisiana'
  },
  {
    'id': 20,
    'abbr': 'MA',
    'name': 'Massachusetts'
  },
  {
    'id': 21,
    'abbr': 'MD',
    'name': 'Maryland'
  },
  {
    'id': 22,
    'abbr': 'ME',
    'name': 'Maine'
  },
  {
    'id': 23,
    'abbr': 'MI',
    'name': 'Michigan'
  },
  {
    'id': 24,
    'abbr': 'MN',
    'name': 'Minnesota'
  },
  {
    'id': 25,
    'abbr': 'MO',
    'name': 'Missouri'
  },
  {
    'id': 26,
    'abbr': 'MS',
    'name': 'Mississippi'
  },
  {
    'id': 27,
    'abbr': 'MT',
    'name': 'Montana'
  },
  {
    'id': 28,
    'abbr': 'NC',
    'name': 'North Carolina'
  },
  {
    'id': 29,
    'abbr': 'ND',
    'name': 'North Dakota'
  },
  {
    'id': 30,
    'abbr': 'NE',
    'name': 'Nebraska'
  },
  {
    'id': 31,
    'abbr': 'NH',
    'name': 'New Hampshire'
  },
  {
    'id': 32,
    'abbr': 'NJ',
    'name': 'New Jersey'
  },
  {
    'id': 33,
    'abbr': 'NM',
    'name': 'New Mexico'
  },
  {
    'id': 34,
    'abbr': 'NV',
    'name': 'Nevada'
  },
  {
    'id': 35,
    'abbr': 'NY',
    'name': 'New York'
  },
  {
    'id': 36,
    'abbr': 'OH',
    'name': 'Ohio'
  },
  {
    'id': 37,
    'abbr': 'OK',
    'name': 'Oklahoma'
  },
  {
    'id': 38,
    'abbr': 'OR',
    'name': 'Oregon'
  },
  {
    'id': 39,
    'abbr': 'PA',
    'name': 'Pennsylvania'
  },
  {
    'id': 40,
    'abbr': 'RI',
    'name': 'Rhode Island'
  },
  {
    'id': 41,
    'abbr': 'SC',
    'name': 'South Carolina'
  },
  {
    'id': 42,
    'abbr': 'SD',
    'name': 'South Dakota'
  },
  {
    'id': 43,
    'abbr': 'TN',
    'name': 'Tennessee'
  },
  {
    'id': 44,
    'abbr': 'TX',
    'name': 'Texas'
  },
  {
    'id': 45,
    'abbr': 'UT',
    'name': 'Utah'
  },
  {
    'id': 46,
    'abbr': 'VA',
    'name': 'Virginia'
  },
  {
    'id': 47,
    'abbr': 'VT',
    'name': 'Vermont'
  },
  {
    'id': 48,
    'abbr': 'WA',
    'name': 'Washington'
  },
  {
    'id': 49,
    'abbr': 'WI',
    'name': 'Wisconsin'
  },
  {
    'id': 50,
    'abbr': 'WV',
    'name': 'West Virginia'
  },
  {
    'id': 51,
    'abbr': 'WY',
    'name': 'Wyoming'
  }
];

export const TIME_ZONES = [
  { 'id': 1, 'name': '(GMT) Casablanca', 'dst': 1, 'gmt': 0 },
  { 'id': 2, 'name': '(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London', 'dst': 1, 'gmt': 0 },
  { 'id': 3, 'name': '(GMT) Monrovia, Reykjavik', 'dst': 0, 'gmt': 0 },
  { 'id': 4, 'name': '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna', 'dst': 1, 'gmt': 1 },
  { 'id': 5, 'name': '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague', 'dst': 1, 'gmt': 1 },
  { 'id': 6, 'name': '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris', 'dst': 1, 'gmt': 1 },
  { 'id': 7, 'name': '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb', 'dst': 1, 'gmt': 1 },
  { 'id': 8, 'name': '(GMT+01:00) West Central Africa', 'dst': 0, 'gmt': 1 },
  { 'id': 9, 'name': '(GMT+02:00) Amman', 'dst': 1, 'gmt': 2 },
  { 'id': 10, 'name': '(GMT+02:00) Athens, Bucharest, Istanbul', 'dst': 1, 'gmt': 2 },
  { 'id': 11, 'name': '(GMT+02:00) Beirut', 'dst': 1, 'gmt': 2 },
  { 'id': 12, 'name': '(GMT+02:00) Cairo', 'dst': 1, 'gmt': 2 },
  { 'id': 13, 'name': '(GMT+02:00) Harare, Pretoria', 'dst': 0, 'gmt': 2 },
  { 'id': 14, 'name': '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius', 'dst': 1, 'gmt': 2 },
  { 'id': 15, 'name': '(GMT+02:00) Jerusalem', 'dst': 1, 'gmt': 2 },
  { 'id': 16, 'name': '(GMT+02:00) Minsk', 'dst': 1, 'gmt': 2 },
  { 'id': 17, 'name': '(GMT+02:00) Windhoek', 'dst': 1, 'gmt': 2 },
  { 'id': 18, 'name': '(GMT+03:00) Baghdad', 'dst': 1, 'gmt': 3 },
  { 'id': 19, 'name': '(GMT+03:00) Kuwait, Riyadh', 'dst': 0, 'gmt': 3 },
  { 'id': 20, 'name': '(GMT+03:00) Moscow, St. Petersburg, Volgograd', 'dst': 1, 'gmt': 3 },
  { 'id': 21, 'name': '(GMT+03:00) Nairobi', 'dst': 0, 'gmt': 3 },
  { 'id': 22, 'name': '(GMT+03:00) Tbilisi', 'dst': 0, 'gmt': 3 },
  { 'id': 23, 'name': '(GMT+03:30) Tehran', 'dst': 1, 'gmt': 3 },
  { 'id': 24, 'name': '(GMT+04:00) Abu Dhabi, Muscat', 'dst': 0, 'gmt': 4 },
  { 'id': 25, 'name': '(GMT+04:00) Baku', 'dst': 1, 'gmt': 4 },
  { 'id': 26, 'name': '(GMT+04:00) Caucasus Standard Time', 'dst': 0, 'gmt': 4 },
  { 'id': 27, 'name': '(GMT+04:00) Port Louis', 'dst': 1, 'gmt': 4 },
  { 'id': 28, 'name': '(GMT+04:00) Yerevan', 'dst': 1, 'gmt': 4 },
  { 'id': 29, 'name': '(GMT+04:30) Kabul', 'dst': 0, 'gmt': 4 },
  { 'id': 30, 'name': '(GMT+05:00) Ekaterinburg', 'dst': 1, 'gmt': 5 },
  { 'id': 31, 'name': '(GMT+05:00) Islamabad, Karachi', 'dst': 1, 'gmt': 5 },
  { 'id': 32, 'name': '(GMT+05:00) Tashkent', 'dst': 0, 'gmt': 5 },
  { 'id': 33, 'name': '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi', 'dst': 0, 'gmt': 5 },
  { 'id': 34, 'name': '(GMT+05:30) Sri Jayawardenepura', 'dst': 0, 'gmt': 5 },
  { 'id': 35, 'name': '(GMT+05:45) Kathmandu', 'dst': 0, 'gmt': 5 },
  { 'id': 36, 'name': '(GMT+06:00) Almaty, Novosibirsk', 'dst': 1, 'gmt': 6 },
  { 'id': 37, 'name': '(GMT+06:00) Astana, Dhaka', 'dst': 0, 'gmt': 6 },
  { 'id': 38, 'name': '(GMT+06:30) Yangon (Rangoon)', 'dst': 0, 'gmt': 6 },
  { 'id': 39, 'name': '(GMT+07:00) Bangkok, Hanoi, Jakarta', 'dst': 0, 'gmt': 7 },
  { 'id': 40, 'name': '(GMT+07:00) Krasnoyarsk', 'dst': 1, 'gmt': 7 },
  { 'id': 41, 'name': '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi', 'dst': 0, 'gmt': 8 },
  { 'id': 42, 'name': '(GMT+08:00) Irkutsk, Ulaan Bataar', 'dst': 1, 'gmt': 8 },
  { 'id': 43, 'name': '(GMT+08:00) Kuala Lumpur, Singapore', 'dst': 0, 'gmt': 8 },
  { 'id': 44, 'name': '(GMT+08:00) Perth', 'dst': 1, 'gmt': 8 },
  { 'id': 45, 'name': '(GMT+08:00) Taipei', 'dst': 0, 'gmt': 8 },
  { 'id': 46, 'name': '(GMT+09:00) Osaka, Sapporo, Tokyo', 'dst': 0, 'gmt': 9 },
  { 'id': 47, 'name': '(GMT+09:00) Seoul', 'dst': 0, 'gmt': 9 },
  { 'id': 48, 'name': '(GMT+09:00) Yakutsk', 'dst': 1, 'gmt': 9 },
  { 'id': 49, 'name': '(GMT+09:30) Adelaide', 'dst': 1, 'gmt': 9 },
  { 'id': 50, 'name': '(GMT+09:30) Darwin', 'dst': 0, 'gmt': 9 },
  { 'id': 51, 'name': '(GMT+10:00) Brisbane', 'dst': 0, 'gmt': 10 },
  { 'id': 52, 'name': '(GMT+10:00) Canberra, Melbourne, Sydney', 'dst': 1, 'gmt': 10 },
  { 'id': 53, 'name': '(GMT+10:00) Guam, Port Moresby', 'dst': 0, 'gmt': 10 },
  { 'id': 54, 'name': '(GMT+10:00) Hobart', 'dst': 1, 'gmt': 10 },
  { 'id': 55, 'name': '(GMT+10:00) Vladivostok', 'dst': 1, 'gmt': 10 },
  { 'id': 56, 'name': '(GMT+11:00) Magadan, Solomon Is., New Caledonia', 'dst': 0, 'gmt': 11 },
  { 'id': 57, 'name': '(GMT+12:00) Auckland, Wellington', 'dst': 1, 'gmt': 12 },
  { 'id': 58, 'name': '(GMT+12:00) Fiji, Kamchatka, Marshall Is.', 'dst': 0, 'gmt': 12 },
  { 'id': 59, 'name': '(GMT+13:00) Nukualofa', 'dst': 0, 'gmt': 13 },
  { 'id': 60, 'name': '(GMT-01:00) Azores', 'dst': 1, 'gmt': -1 },
  { 'id': 61, 'name': '(GMT-01:00) Cape Verde Is.', 'dst': 0, 'gmt': -1 },
  { 'id': 62, 'name': '(GMT-02:00) Mid-Atlantic', 'dst': 1, 'gmt': -2 },
  { 'id': 63, 'name': '(GMT-03:00) Brasilia', 'dst': 1, 'gmt': -3 },
  { 'id': 64, 'name': '(GMT-03:00) Buenos Aires', 'dst': 1, 'gmt': -3 },
  { 'id': 65, 'name': '(GMT-03:00) Georgetown', 'dst': 0, 'gmt': -3 },
  { 'id': 66, 'name': '(GMT-03:00) Greenland', 'dst': 1, 'gmt': -3 },
  { 'id': 67, 'name': '(GMT-03:00) Montevideo', 'dst': 1, 'gmt': -3 },
  { 'id': 68, 'name': '(GMT-03:30) Newfoundland', 'dst': 1, 'gmt': -3 },
  { 'id': 69, 'name': '(GMT-04:00) Atlantic Time (Canada)', 'dst': 1, 'gmt': -4 },
  { 'id': 70, 'name': '(GMT-04:00) La Paz', 'dst': 0, 'gmt': -4 },
  { 'id': 71, 'name': '(GMT-04:00) Manaus', 'dst': 1, 'gmt': -4 },
  { 'id': 72, 'name': '(GMT-04:00) Santiago', 'dst': 1, 'gmt': -4 },
  { 'id': 73, 'name': '(GMT-04:30) Caracas', 'dst': 0, 'gmt': -4 },
  { 'id': 74, 'name': '(GMT-05:00) Bogota, Lima, Quito, Rio Branco', 'dst': 0, 'gmt': -5 },
  { 'id': 75, 'name': '(GMT-05:00) Eastern Time (US & Canada)', 'dst': 1, 'gmt': -5 },
  { 'id': 76, 'name': '(GMT-05:00) Indiana (East)', 'dst': 0, 'gmt': -5 },
  { 'id': 77, 'name': '(GMT-06:00) Central America', 'dst': 0, 'gmt': -6 },
  { 'id': 78, 'name': '(GMT-06:00) Central Time (US & Canada)', 'dst': 1, 'gmt': -6 },
  { 'id': 79, 'name': '(GMT-06:00) Guadalajara, Mexico City, Monterrey - New', 'dst': 1, 'gmt': -6 },
  { 'id': 80, 'name': '(GMT-06:00) Guadalajara, Mexico City, Monterrey - Old', 'dst': 1, 'gmt': -6 },
  { 'id': 81, 'name': '(GMT-06:00) Saskatchewan', 'dst': 0, 'gmt': -6 },
  { 'id': 82, 'name': '(GMT-07:00) Arizona', 'dst': 0, 'gmt': -7 },
  { 'id': 83, 'name': '(GMT-07:00) Chihuahua, La Paz, Mazatlan - New', 'dst': 1, 'gmt': -7 },
  { 'id': 84, 'name': '(GMT-07:00) Chihuahua, La Paz, Mazatlan - Old', 'dst': 1, 'gmt': -7 },
  { 'id': 85, 'name': '(GMT-07:00) Mountain Time (US & Canada)', 'dst': 1, 'gmt': -7 },
  { 'id': 86, 'name': '(GMT-08:00) Pacific Time (US & Canada)', 'dst': 1, 'gmt': -8 },
  { 'id': 87, 'name': '(GMT-08:00) Tijuana, Baja California', 'dst': 1, 'gmt': -8 },
  { 'id': 88, 'name': '(GMT-09:00) Alaska', 'dst': 1, 'gmt': -9 },
  { 'id': 89, 'name': '(GMT-10:00) Hawaii', 'dst': 0, 'gmt': -10 },
  { 'id': 90, 'name': '(GMT-11:00) Midway Island, Samoa', 'dst': 0, 'gmt': -11 },
  { 'id': 91, 'name': '(GMT-12:00) International Date Line West', 'dst': 0, 'gmt': -12 },
  { 'id': 92, 'name': '(GMT+08:00) Hong Kong', 'dst': 0, 'gmt': 8 },
];

export const IRX_ELIGIBLE_OPTIONS = { ALL: "All", YES: "Yes", NO: "No" };

